// extracted by mini-css-extract-plugin
export default {"productDescription":"xaa-z","featuredDescription":"yaa-z","description":"zaa-z","more":"Aaa-z","descriptionSku":"Baa-z"};